import { DatalayersMap, fields, IDatalayersMap, IDatalayersMapFactory } from "../omnia"

export class DatalayersMapFactory implements IDatalayersMapFactory {

    static $inject = [
        "OmniaFieldsMapContext"
    ]

    constructor(
        private readonly context: fields.IFieldsMapContainerContext
    ) {

    }
    createMap(options?: fields.IFieldsMapContainerOptions): IDatalayersMap {
        return new DatalayersMap(this.context, options)
    }

}
